import { render, staticRenderFns } from "./TextBubbleContainer.vue?vue&type=template&id=6a2bfe9d&"
import script from "./TextBubbleContainer.vue?vue&type=script&lang=js&"
export * from "./TextBubbleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports